import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface AreaChartProps {
  categories: string[];
  series: Array<{ name: string; data: number[]; color?: string }>;
  stacked?: boolean;
  height?: number | string;
  loading?: boolean;
  color?: string;
  showGrid?: boolean;
  xAxisLabel?: string;
  yAxisLabel?: string;
}

export function AreaChart({
  categories,
  series,
  stacked,
  height,
  loading,
  color,
  showGrid = true,
  xAxisLabel,
  yAxisLabel,
}: AreaChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'axis' },
    legend: { bottom: 0 },
    grid: { left: 50, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: {
      type: 'category',
      data: categories,
      boundaryGap: false,
      name: xAxisLabel,
      splitLine: showGrid ? undefined : { show: false },
    },
    yAxis: {
      type: 'value',
      name: yAxisLabel,
      splitLine: showGrid ? undefined : { show: false },
    },
    series: series.map((s) => ({
      name: s.name,
      type: 'line',
      smooth: true,
      stack: stacked ? 'stack' : undefined,
      areaStyle: { opacity: stacked ? 0.5 : 0.35, color: color ?? s.color },
      data: s.data,
      itemStyle: { color: color ?? s.color },
    })),
  };
  return <EChart option={option} height={height} loading={loading} />;
}
